import { render, staticRenderFns } from "./SVO.vue?vue&type=template&id=22e29d40&scoped=true&"
import script from "./SVO.vue?vue&type=script&lang=js&"
export * from "./SVO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e29d40",
  null
  
)

export default component.exports